import * as React from "react";
import { Duration } from "azure-devops-ui/Duration";

export default class DurationExample extends React.Component {
    public render(): JSX.Element {
        return <Duration startDate={new Date()} />;
    }
}
